import React, { useCallback } from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import call from 'utils/functions/call.util';

import CN from './CashupLogItemModal.module.scss';

const CashupLogItemModal = ({ onRequestClose, onConfirm, total, onClose }) => {
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    call(`CashupLogItemModal.onRequestClose`, onRequestClose);
    call(`CashupLogItemModal.onClose`, onClose);
  }, [onClose, onRequestClose]);

  const handleRefund = useCallback(() => {
    call(`CashupLogItemModal.onConfirm`, onConfirm);
    call(`CashupLogItemModal.onRequestClose`, onRequestClose);
  }, [onConfirm, onRequestClose]);

  return (
    <SalonModal tag="CashupLogItemModal__modal" isOpen>
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={handleClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.modalImage}>
          <div className={CN.iconContainer}>
            <Icon variant="refund" />
          </div>
        </div>
        <div className={CN.modalContent}>
          <div className={CN.title}>
            <Space>{t('cashUp.cashupLogs.itemModal.refund')}</Space>

            <span className={CN.focus}>
              <CurrencySign value={total} />
            </span>
          </div>
          <span className={CN.modalText}>
            {t('cashUp.cashupLogs.itemModal.to')}
            <span className={CN.focus}> {t('cashUp.cashupLogs.itemModal.edit')}</span> {t('cashUp.cashupLogs.itemModal.descriptionPart1')}
            <span className={CN.focus}> {t('cashUp.cashupLogs.itemModal.reCheckout')}</span> {t('cashUp.cashupLogs.itemModal.descriptionPart2')}
          </span>
          <div className={CN.note}>{t('cashUp.cashupLogs.itemModal.note')}</div>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="primaryForce" onClick={handleRefund}>
          <span className={CN.buttonSpace}>{t('cashUp.cashupLogs.buttons.refundBill')}</span>
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};

// noinspection JSUnusedGlobalSymbols
export default CashupLogItemModal;
